import React, { useRef , useEffect, useState} from 'react';
import { useLocation } from 'react-router-dom'
import { inject, observer } from 'mobx-react';
import DataGrid, {
    Column,
    HeaderFilter,
    Lookup
} from 'devextreme-react/data-grid';
import { Template } from 'devextreme-react/core/template';
import { createStore } from 'devextreme-aspnet-data-nojquery';

import apiUrls from '../../common/api/api-urls';
import { trans } from '../../common/utils';
import { languages } from '../../configs/i18n';
import { setUnactiveRows } from '../../common/utils';
import {
    LanguageTemplate,
    dataGridDefaultSettings,
} from '../../components';

const ServiceProviderBalancePage = ({
                                        store: {
                                            languages: { table },
                                        },

                                    }) =>
{
    const [data, setData] = useState([]);

    const roles = JSON.parse(localStorage.getItem('roles') || '[]');

    const canAdd = roles.includes('Administrator');
    const canDelete = roles.includes('Administrator');
    const canUpdate = roles.includes('Manager'); // если нужно


    useEffect(() => {
        fetch(apiUrls.info.providerBalance+'?skip=0&take=20&languageid=2')
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Ошибка при получении данных');
                }
                return response.json();
            })
            .then((json) => {
                console.log('Ответ:', json);
                setData(json.data); // 👈 теперь передаём именно массив
            })
            .catch((error) => {
                console.error('Ошибка:', error);
            });
    }, []);


    const updateBalance = () => {
        fetch(apiUrls.info.providerBalance+'?skip=0&take=20&languageid=2')
            .then((response) => response.json())
            .then((json) => setData(json.data))
            .catch((error) => console.error('Ошибка:', error));
    };


    return (
        <>
            <div>


                <div>

                </div>


                <div className="row">
                    <div className="col-lg-12">
                        <div style={{padding: '20px', fontFamily: 'Arial, sans-serif'}}>
                            <h5>TokenStream {trans('Баланс')}</h5>
                            {Array.isArray(data) && data.length > 0 ? (
                                <div style={balanceContainerStyle}>
                                    {data.map((item, index) => (
                                        <div key={index} style={balanceItemStyle}>
                                            <p style={balanceTextStyle}>Balance: <strong>{item.balance} qəp  =   {item.balance/100} AZN</strong></p>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <p>Нет данных</p>
                            )}
                        </div>
                    </div>

                </div>

                <div className="row">
                    <div className="col-lg-12">
                        <DataGrid
                            {...dataGridDefaultSettings({
                                settingStorageName: 'BMA_grid_info_ProviderBalance_trans_USERID',
                                url: apiUrls.info.providerBalanceTrans,
                                key: 'transactionID',
                                language: languages.languageId[table],
                                editorPreparingArray: 'transactionID',
                                languagePicker: false,
                                toolbarCenter: `${trans('Транзакция')}`,

                                editing: {
                                    allowAdding: canAdd,
                                    allowUpdating: canUpdate,
                                    allowDeleting: canDelete,
                                    mode: "row"
                                },
                                columnFixing: {enabled: false},
                            })}

                            onRowPrepared={setUnactiveRows}
                            onRowInserted={updateBalance}
                            onRowUpdated={updateBalance}
                            onRowRemoved={updateBalance}
                        >
                            <HeaderFilter visible={true} allowSearch={true}/>


                            <Column
                                dataField={'serviceProviderID'}
                                caption={trans('Сервис провайдер')}
                                dataType={'number'}
                                width={300}
                                allowSearch={false}
                                allowHeaderFiltering={false}
                            >
                                <Lookup
                                    dataSource={createStore({
                                        key: 'key',
                                        loadUrl: apiUrls.lookup.serviceProvider,
                                        onBeforeSend: (method, ajaxOptions) => {
                                            //ajaxOptions.data.languageid = 1;
                                            ajaxOptions.xhrFields = {
                                                withCredentials: true,
                                            };
                                        },
                                    })}
                                    displayExpr={'value'}
                                    valueExpr={'key'}
                                />
                            </Column>


                            <Column
                                dataField={'balance'}
                                caption={trans('Баланс')}
                                dataType={'number'}
                                width={300}
                                allowSearch={false}
                                allowHeaderFiltering={false}
                            />


                            <Column
                                dataField={'idt'}
                                caption={trans('Дата вставки')}
                                dataType={'datetime'}
                                format={'dd/MM/yyyy HH:mm:ss'}
                                width={280}
                                visible={true}
                                allowFixing={false}
                                allowEditing={false}
                                allowSearch={false}
                                allowHeaderFiltering={false}
                            />
                            <Column
                                type="buttons"
                                width={110}
                                buttons={['edit', 'delete']}
                            />

                            <Template
                                name={'languageBar'}
                                render={() => <LanguageTemplate/>}
                            />
                        </DataGrid>
                    </div>
                </div>

            </div>


        </>

    );
};


const balanceContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
};

const balanceItemStyle = {
    background: '#f0f0f0',
    padding: '15px',
    borderRadius: '8px',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
    fontSize: '18px',
};

const balanceTextStyle = {
    margin: '0',
    color: '#333',
    fontSize: '20px',
};

export default inject('store')(observer(ServiceProviderBalancePage));
